import { api } from '@/api'
import type { User } from '@/types/models'

export interface LoginPayload {
  email: string
  password: string
  remember?: boolean
}

export const authApi = {
  me: (): Promise<User> => api.get<{ data: User }>('/api/user').then((r) => r.data),

  login: (payload: LoginPayload): Promise<User> =>
    api.post<{ data: User }>('/api/login', payload).then((r) => r.data),

  logout: (): Promise<void> => api.post<void>('/api/logout'),

  forgotPassword: (email: string): Promise<void> =>
    api.post<void>('/api/forgot-password', { email }),

  resetPassword: (payload: {
    token: string
    email: string
    password: string
    password_confirmation: string
  }): Promise<void> => api.post<void>('/api/reset-password', payload),
}